export default __webpack_public_path__ + "static/media/diktis_kikloforiakis_simforisis_big.6c759a58.svg";